import en from '../../../../../../assets/language/en.json';
import de from '../../../../../../assets/language/de.json';
import { uniqueId } from 'lodash';

const actionNameFormModel = {
    formId: uniqueId('form-'),
    formField: {
        nameEn: {
            name: 'nameEn',
            label: en.name,
            requiredErrorMsg: en.name_required_error_msg,
        },
        nameDe: {
            name: 'nameDe',
            label: de.name,
            requiredErrorMsg: de.name_required_error_msg,
        },
    },
};

const formModels = {
    actionNameFormModel,
};

export default formModels;
